<template>
  <v-card flat tile v-if="disabledFlag" class="pt-5">
    <v-card-title class="mb-3">
      <v-layout justify-center>
        <div v-if="status==='readonly'" style="text-align: justify">
          <span style="font-weight: bold;font-size: 24px;width:100%;display: inline-block">
            {{passStatus}}
          </span>
        </div>
        <v-layout v-else-if="self.resultMsg.length>0" column justify-center>
          <v-flex xs12 v-for="m in self.resultMsg">
            <div v-if="self.result==='1'" style="text-align: justify">
              <span v-if="self.authType.indexOf('离退教工')!==-1||self.authType.indexOf('访客')!==-1" style="font-weight: bold;font-size: 24px;width:100%;display: inline-block" class="warning--text">{{m}}</span>
              <span v-else style="font-weight: bold;color:green;font-size: 24px;width:100%;display: inline-block">{{m}}</span>
            </div>
            <div v-else-if="self.result==='2'" style="text-align: justify">
              <span style="font-weight: bold;color:blue;font-size: 24px;width:100%;display: inline-block">{{m}}</span>
            </div>
            <div v-else-if="self.result==='0'" style="text-align: justify">
              <span style="font-weight: bold;color: red;font-size: 24px;width:100%;display: inline-block">{{m}}</span>
            </div>
          </v-flex>
        </v-layout>
        <div style="text-align: justify"  v-else>
          <span style="font-weight: bold;color:red;font-size: 24px;width:100%;display: inline-block">请重新扫码登记</span>
        </div>
      </v-layout>
    </v-card-title>
    <v-list>
      <template  v-for="(opt, i) in opts">
        <v-divider v-if="opt.divider" :key="i + 'divider'"></v-divider>
        <v-list-tile v-if="opt.icon || opt.title|| opt.subTitle" :key="i" class="">
          <v-list-tile-action>
            <v-layout>
              <v-icon v-text="opt.icon"></v-icon>
              <span style="" class="ml-2 mr-2">{{opt.subTitle}}</span>
            </v-layout>
          </v-list-tile-action>
          <v-list-tile-content >
            <!--<v-list-tile-sub-title :style="opt.style" class="mb-2">{{opt.subTitle}}</v-list-tile-sub-title>-->
            <v-list-tile-title :class="(opt.title.indexOf('学生')!==-1 ||opt.title.indexOf('研究生')!==-1||opt.title.indexOf('继教生')!==-1)? '':''"  v-if="opt.type===''">
              <v-layout justify-end>
                <h2>{{opt.title.trim() || 'N/A'}}</h2>
              </v-layout>
            </v-list-tile-title>
            <v-list-tile-title :class="[opt.title ? 'primary--text':'grey--text']"  v-else>
              <v-layout justify-end>
                <h3 style="width: 180px">
                  <Marquee :lists="opt.arr"></Marquee>
                </h3>
              </v-layout>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-subheader v-if="opt.subheader" :key="i + 'subheader'">{{opt.subheader}}</v-subheader>
      </template>
    </v-list>
    <v-layout justify-center v-if="status==='readonly'" >
      <v-btn  color="primary" @click="returnRecord">返回</v-btn>
    </v-layout>
    <v-layout justify-center v-if="self.result==='1'" >
      <v-btn  color="primary" @click="goToSignCode">前往个人二维码</v-btn>
    </v-layout>
     <div style="text-align:center;padding:5px;margin-top:20px">
          <img src="../../../assets/bwc_wechat.png" style="width:50px;height:auto" :class="'logo-'+encodeData"/>
        </div>
    <v-dialog v-model="confirmDialog.activated" width="700">
      <v-layout column>
        <v-card class="pa-3">
          <v-layout column>
            <div style="max-height:400px;overflow:auto;text-align:justify;padding:10px" v-html="confirmDialog.msg"></div>
            <v-layout justify-center>
              <v-btn class="primary" @click="sign" :loading="loading" :disabled="disabledFlag===true">进校登记</v-btn>
              <v-btn class="error" @click="goToTempSelfSignRecord">取消</v-btn>
            </v-layout>
          </v-layout>
        </v-card>
      </v-layout>
    </v-dialog>
  </v-card>
  <v-layout align-center class="mt-4" column style="height: 200px" v-else>
    <v-progress-circular
      :color="'accent'"
      :value="100"
      size="50"
      indeterminate
    ></v-progress-circular>
    <span class="mt-2">正在进行扫码登记</span>
  </v-layout>
</template>

<script>
  import {time} from '../../../ladmin/utils/time'
  import Marquee  from '@/components/Marquee'
  export default {
    name: 'tempSelfSign',
    computed: {
      opts () {
        return [
          {divider: true},
          {
            icon: '$vuetify.icons.person',
            title: this.self.name,
            subTitle: '用户姓名',
            style:"font-weight:bold",
            type:''
          },
          {
            icon: '$vuetify.icons.group',
            title: this.self.authType,
            subTitle: '登记类型',
            style:"font-weight:bold",
            type:''
          },
          {
            icon: '$vuetify.icons.timer',
            title: this.self.passTime,
            subTitle: '登记时间',
            style:"font-weight:bold",
            type:"Marquee",
            arr:[this.self.passTime]
          },
        /*  {divider: true},
          {
            icon: '$vuetify.icons.parkingLot',
            title: this.self.parkLot,
            subTitle: '所在校区',
            style:"font-size:16px"
          },
          {
            icon: '$vuetify.icons.location',
            title: this.self.controller,
            subTitle: '登记卡口',
            style:"font-size:16px"
          },
          {
            icon: '$vuetify.icons.idCard',
            title: this.self.loginId,
            subTitle: '用户账号',
            style:"font-size:16px"
          },
          {
            icon: '$vuetify.icons.phone',
            title: this.self.phone,
            subTitle: '手机号码',
            style:"font-size:16px"
          },
          {
            icon: '$vuetify.icons.org',
            title: this.self.orgName,
            subTitle: '所在单位',
            style:"font-size:16px"
          },*/
        ]
      },
    },
    components:{
      Marquee
    },
    data () {
      return {
        encodeData:"",
        loading: false,
        disabledFlag:false,
        status:'',
        confirmDialog:{
          activated:false,
          msg:"【电子科技大学】全体师生员工：<br/>" +
            "\t根据学校应对新型冠状病毒感染肺炎疫情防控工作领导小组工作部署，为了广大师生健康安全，自2020年1月28日下午6时起，实施校门临时管控措施。<br/>" +
            "1、暂停校园交通管理系统的车行和人行预约功能；<br/>" +
            "2、所有未经注册认证车辆一律不准许进入校园；<br/>" +
            "3、校园不接待参观者和无关人员，本校师生员工除因保障、值守或应急等工作事由之外原则上不得进校，不得携带家属及校外亲友进校；<br/>" +
            "4、清水河校区仅开放西门人行和车行通道，沙河校区仅开放东门人行和车行通道，其他门的人行和车行通道全部关闭；<br/>" +
            "5、所有入校车辆和人员必须凭有效身份证件 本校师生证明证件（如工作证、工牌或一卡通等）进校；<br/>" +
            "6、请广大教职工理解并配合校门岗位人员做好体温检测、盘问和信息登记工作。<br/>" +
            "特殊时期，特殊管理，由此带来的不便，敬请大家理解、支持和配合。"
        },
        self:{
          name:'',
          loginId:'',
          phone:'',
          orgName:'',
          authType:'',
          controller:'',
          parkLot:"",
          result:"",
          passTime:"",
          resultMsg:[]
        },
        passStatus:''
      }
    },
    created () {
      this.confirmDialog.activated = true
      if(this.$route.query.status!==undefined){
        if(this.$route.query.status==='readonly'){
          this.status = 'readonly'
          this.self.passTime = time.stringify(this.$route.query.passTime)
          this.disabledFlag = true
          this.confirmDialog.activated = false
          this.passStatus = this.$route.query.passStatus
          if(this.passStatus.indexOf('授权有效')){
            this.self.result='1'
          }else{
            this.self.result='0'
          }
        }
      }
      this.getSelfInfo()
     // this.getController()
      this.sign()
    },
    methods: {
      async getSelfInfo(){
        let res = await this.$store.dispatch('wx/getSelfInfo')
        if(res.data.status === 1){
          this.dealSelfInfo(res.data.data)
          this.encodeUserInfo(res.data.data)
        }else{
          this.$L.alert('error',{message:'未查询到该用户信息'})
        }
      },
      encodeUserInfo(data){
        const loginId = data.userInfo.loginId
        const encodeData = window.btoa(`loginId=${loginId}`)
        //console.log("加密数据",encodeData)
        this.encodeData = encodeData.substring(0,encodeData.length-1)
        //console.log(this.encodeData)
      },
      dealSelfInfo(data){
        if(data.userInfo.userGroups&&data.userInfo.userGroups.length!==0){
          for(let i=0;i<data.userInfo.userGroups.length;i++){
            if(data.userInfo.userGroups[i].groupTypes[0].name === 'reg'){
              this.self.authType =data.userInfo.userGroups[i].name
            }
          }
        }
        this.self.name = data.userInfo.name
        this.self.loginId = data.userInfo.loginId
        this.self.phone = data.userInfo.mobilePhone
        if(data.selfConfig&&data.selfConfig.currentOrg){
          this.self.orgName = data.selfConfig.currentOrg.name
        }
        if(this.self.authType!==""&&this.self.authType){
          this.self.authType = this.self.authType.substring(4)
        }
      },
      async getController(){
        let controllerId = this.$route.query.controllerId
        let {items} = await this.$store.dispatch('park/getUnDirControllerList', {pagination: {page: 1, rowsPerPage: 10}, search: {key: 'id', value: controllerId}})
        if(items.length===0){
          this.$L.alert('error',{message:'未查询到卡口信息'})
        }else{
          let c = items[0]
          this.self.parkLot = c.park[0].name
          this.self.controller = c.name
        }
      },
      async signConfirm () {
        let {res, close} = await this.$L.confirm({
          title: '确认进行打卡登记？',
        })
        if (res) {
          try {
            await this.sign()
          }
          catch (e) {
            this.$L.alert('error', e.message)
          }
        }
        close()
      },
      isVisitor(data){
        let groups = data.userInfo.userGroups
        for(let i=0;i<groups.length;i++){
          if(groups[i].groupTypes[0].name==='reg'){
            let name =groups[i].name
            if(name.indexOf('【登记】注册访客')!==-1){
              return true
            }else{
              return false
            }
          }
        }
        return false
      },
      async sign(){
        this.loading = true
        try {
          let res = await this.$store.dispatch('wx/tempSelfSign',this.$route.query.controllerId)
          if(res.data.status===1){
            this.disabledFlag = true
            this.confirmDialog.activated=false
            this.self.result = "1"
            this.self.resultMsg = res.data.msg.split('|')
            this.self.passTime = time.stringify(new Date().getTime())
            this.$L.alert('success',{title:"进校登记成功",message:res.data.msg})
          }else if(res.data.status===0){
            this.disabledFlag = true
            this.confirmDialog.activated=false
            this.self.result = "0"
            this.self.resultMsg = res.data.msg.split('|')
            this.self.passTime = time.stringify(new Date().getTime())
            /*this.$L.alert('error',{title:"进校登记失败",message:res.data.msg})*/
          }
          else if(res.data.status===2){
            this.disabledFlag = true
            this.confirmDialog.activated=false
            this.self.result = "2"
            this.self.resultMsg = res.data.msg.split('|')
            this.self.passTime = time.stringify(new Date().getTime())
            /*this.$L.alert('error',{title:"进校登记失败",message:res.data.msg})*/
          }
          else{
            this.self.result = "0"
            this.self.resultMsg = res.data.msg.split('|')
            /*this.$L.alert('error',{message:"进校登记失败，原因:"+res.data.msg})*/
          }
        }catch (e) {

        }finally {
          this.loading = false
        }
      },
      goToTempSelfSignRecord(){
        this.$router.replace({name:'tempSelfSignRecord'})
      },
      returnRecord(){
        this.$router.replace({name:"tempSelfSignRecord"})
      },
      goToSignCode(){
        this.$router.replace({name:'qrcode_gen'})
      }
    }
  }
</script>

<style scoped>

</style>
